<template>
    <v-row justify="center" class="border-radius-3">
        <v-dialog 
            v-model="dialog"
            color="#323A46"
            persistent
            :width="$vuetify.breakpoint.xs ? '90%' : '70%'"
            content-class="border-radius-2 pt-0"
            overlay-color="#7764CA"
            overlay-opacity="1"
            >
            <div class="onboarding-logo-wrapper">
                <v-img 
                    :src="logo"
                    width="100"
                    class="mx-auto">
                </v-img>
            </div>
            <v-row class="progress-bar-wrapper ma-0">
                <v-col cols="12" class="position-relative">
                    <v-progress-linear
                    background-color="#514585"
                    color="#C4BBE7"
                    v-model="completedTasksPercentage"
                    height="18"
                    class="pointer-events-none border-progress-bar"
                    rounded
                    >
                    <strong>Paso {{ currentPage }} de {{ totalPages - 1 }}</strong>
                </v-progress-linear>
                    <v-img
                    :src="require('@/assets/img/icons/check-stroke.png')"
                    height="48"
                    width="48"
                    class="check-icon"
                    ></v-img>
                </v-col>
            </v-row>
            <v-card class="custom-card category-card-wrapper border-radius-2 mt-14">
                <v-card-title class="d-flex justify-center px-10 position-relative">
                    <v-img
                        :src="require(`@/assets/img/icons/icon-voice-assistant.svg`)"
                        max-height="40px"
                        max-width="40px"
                        :min-width="$vuetify.breakpoint.xs ? '32' : '40'"
                        :min-height="$vuetify.breakpoint.xs ? '32' : '40'"
                        contain
                        class="main-sound-img cursor-pointer category-title-voice"
                        @click="read"
                    ></v-img>
                    <p 
                        class="main-title d-flex justify-center"
                        v-html="$t('initialTour.categories_select')">
                    </p>
                </v-card-title>
                <v-container class="px-0 py-0 height-viewport-100">
                    <div class="d-flex justify-content category-content">
                        <v-row class="pa-0 ma-0 main-categories">
                            <v-col
                                data-cy="choose-avatar"
                                cols="3"
                                sm="2"
                                v-for="(category, index) of categories"
                                :key="index"
                                class="pa-0 ma-2"
                            >
                                <Category :data="category"></Category>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
                <v-card-actions class="d-flex justify-center">
                    <v-btn
                        data-cy="continue-button-category-select"
                        class="bg-gradient-primary px-15 border-radius-1 text-transform-none font-weight-bolder"
                        large
                        dark
                        :loading="btnLoaded"
                        @click="nextPass"
                        >{{ $t('initialTour.continue') }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import UserService from '@/services/users'
import Category from './CategoriesCore/Category.vue'

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    components: {
        Category,
    },
    computed: {
        ...mapState(['categories']),
        ...mapState({
            stCategories: (state) => state.userData.selectedCategories,
            stUserAvatar: (state) => state.userData.avatarSelected,
            stUser: (state) => state.userData.user,
            survey: (state) => state.userData.survey,
        }),
        completedTasksPercentage() {
            if (this.currentPage && this.totalPages) {
                return Math.round((this.currentPage / this.totalPages) * 100);
            } else {
                return 0;
            }
        }
    },
    data() {
        return {
            select_categories: [],
            selectedCategoriesObj: [],
            btnLoaded: false,
            currentPage: 3,
            totalPages: 4,
            logo: require('@/assets/img/brand/logo.svg'),
        }
    },
    methods: {
        ...mapActions('dashboard', [
            'showCategories',
            'showAvatars',
            'showInitialPoll',
            'mountDiagnostic',
            'showFinishPreferencesModal',
        ]),
        ...mapActions('userData', ['changeCategories']),
        searchCategorySelected(categoryId) {
            return this.categories.find(
                (categoryFromList) => Number(categoryId) === Number(categoryFromList.id)
            )
        },
        async nextPass() {
            const vm = this
            document.querySelectorAll('.category-active').forEach((obj) => {
                const id = obj.getAttribute('data-category-id')
                vm.select_categories.push(id)
                vm.selectedCategoriesObj.push(this.searchCategorySelected(id))
            })

            if (this.select_categories.length < 1) {
                this.$modal.error(this.$t('initialTour.msg_categories_not_select'))
                return
            }
            this.changeCategories(this.selectedCategoriesObj)

            this.btnLoaded = true
            await this.updateUserPreferences({
                userId: this.stUser.id,
                avatar: this.stUserAvatar.id,
                userAvatar: this.stUserAvatar.id,
                categories: this.select_categories,
            })
            this.btnLoaded = false
            this.showCategories()
            this.showFinishPreferencesModal()
        },
        updateUserPreferences(data) {
            return new Promise((resolve, reject) => {
                UserService.updateUserPreferences(data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((err) => {
                        console.error(err)
                        reject(err)
                    })
            })
        },
        read(){
            this.play('category_select')
        },
        play(text) {
            if (this.audio && !this.audio.paused) {
                this.audio.pause()
            }
            const audio = new Audio(`${process.env.VUE_APP_VOICE_SAMPLE_URL}onboarding/${text}.mp3`);
            audio.volume = 0.4;
            audio.play()
                .then(() => {
                    this.audio = audio;
                })
                .catch(() => {
                    this.audio = null;
                });
        },
    },
}
</script>
<style lang="scss">

.v-dialog{
    overflow: hidden;
}

.category-content {
    height: 48vh;
    overflow-y: auto;
    overflow-x: hidden;
    @media screen and (max-height: 700px) {
        height: 40vh;
    }
}

.main-categories {
    justify-content: center;
    align-items: self-start;
    align-content: start;
}

.category-img {
    display: block;
    max-width: 52vh;
    height: 65px;
}

.sm-category-img {
    display: block;
    max-width: 52vh;
    height: 4vh;
}

.category-active {
    background: #FFFFFF;
    z-index: 2;
    .category-box {
        // border: 1vh solid #4caf50;
        &::after {
            content: '';
            position: absolute;
            width: calc(100% + 12px);
            height: calc(100% + 12px);
            border-radius: 12px;
            left: -6px;
            top: -6px;
            background: linear-gradient(310.15deg, #A295DA -3.77%, #7764CA 29.51%, #6857B2 65.63%, #514585 93.49%),
            linear-gradient(0deg, #FFFFFF, #FFFFFF);
            z-index: -1;
        }
    }
}

.category-title-voice{
    position: absolute;
    left: 20px;
    top: 21px;
}

.v-dialog{
    .category-card-wrapper{
        max-height: 80vh;
        overflow-y: hidden;
        margin-top: 80px !important;
        @media screen and (max-width: 600px) {
            margin-top: 100px !important;
        }
    }
}

.category-check {
    display: none;
}
.category-active .category-check {
    bottom: -12px;
    right: 0px;
    display: flex;
    position: absolute;
    justify-content: center;
    align-items: center;
}

.category-active .sm-category-img {
    height: 5vh;
}
</style>
